import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  FormTextArea,
  FormSelect,
  FormSelectAlt,
  FormInputAlt,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import {
  CreateAssetRegister,
  GetAssetClass,
  GetCategories,
} from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import { BsDash } from "react-icons/bs";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import style from "./styleJS";
import { CreateCostClass, UpdateCostClass } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import toast from "react-hot-toast";


function CostCenterClassSetup() {
  const { SelectedClass, editMode } = useSelector(state=> state.costCenter);
  // console.log({SelectedClass, editMode});
  const navigate = useNavigate();
  const defaultData = {
    // input any Key-Value pair that doesn't need user input but should be in request body
  };
  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  // const feildArray = useFieldArray({
  //   control: formMethods.control,
  //   name: "classSetups",
  // });
  const dispatch = useDispatch();

  // useEffect(() => {
  //   // dispatch(
      
  //   // );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  function saveClass(data){
    data.retirementDays = parseInt(data.retirementDays);
    toast.loading("Creating Class...");
    dispatch(CreateCostClass(data))
    .then((response)=>{
      console.log({response})
      toast.remove();
      if(response?.payload?.success===false){
        return null;
      } else {
        reset()
        navigate(-1)
      }
    })
  } 

  function updateClass(data){
    data.id = SelectedClass.id
    data.retirementDays = parseInt(data.retirementDays);
    dispatch(UpdateCostClass(data))
    .then((response)=>{
      console.log({response})
      if(response?.meta?.requestStatus==="fulfilled"){
        // reset()
        navigate(-1)
      }
    })
  } 

  return (
    <RouteLayout title={"Finance"}>
      <PageLayout title={"Setup Class"} hasBack={true}>
        <FormProvider {...formMethods}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(editMode? updateClass : saveClass)}
          >
            <section className={DashboardStyle.form_section}>
              <h4 className={style.setup.sectionHeader}>Basic <br/> Information</h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormInputAlt
                    title={"Class name"}
                    camelCase={"costClassName"}
                    placeholder={"Enter Class name"}
                    isOptional={false}
                    defaultValue={editMode? SelectedClass?.name : ""}
                    array={[]}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />
                </div>
                <div>
                  <FormInputAlt
                    title={"Short code"}
                    camelCase={"code"}
                    placeholder={"Enter Short Code"}
                    isOptional={false}
                    defaultValue={editMode? SelectedClass?.code : ""}
                    array={[]}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />
                </div>
                <div>
                  <FormInputAlt
                    title={"Retirement Days"}
                    camelCase={"retirementDays"}
                    placeholder={"Enter Retirement Days"}
                    type="number"
                    isOptional={false}
                    defaultValue={editMode&& SelectedClass?.retirementDays}
                    array={[]}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />
                </div>
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => { reset(); navigate(-1); }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>
              <ActionButtons
                // isLoading={isLoading}
                // disabled={!isValid}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Submit
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

export default CostCenterClassSetup;


